import { fuego } from '@store/firebase';

export async function getEmoticon() {
  const ref = fuego.db.collection('emoticon');
  const emoticonList = await ref.get().then((res) => res.docs);

  const emoticonWrap = emoticonList.map((doc) => {
    return {
      id: doc.id,
      value: doc.data().title,
      photoURL: doc.data().imgURL,
    };
  });

  return emoticonWrap;
}
